// extracted by mini-css-extract-plugin
module.exports = {"modal":"modal_modal__1fU6Y","small":"modal_small__1K0eN","medium":"modal_medium__1qMVx","big":"modal_big__3SQKp","large":"modal_large__xTINi"};